import { NumericFormat } from 'react-number-format';
import { FaSync } from 'react-icons/fa';
import Panel from '~/components/Panel';

interface Props {
    entireFundsRaised: number;
    mipBalance?: number;
    onRefreshBalance?: () => void;
    isRefreshing?: boolean;
}

const FundsRaisedBlock: React.FC<Props> = ({
    entireFundsRaised,
    mipBalance,
    onRefreshBalance,
    isRefreshing = false,
}) => {
    return (
        <>
            <Panel
                addClasses={`border-[#F7F9EA] bg-[#F7F9EA] flex-1 @container`}
            >
                <h2 className='text-[16px]/[24px] font-medium uppercase'>
                    Funds Raised
                </h2>
                <div className='text-[28px]/[44px] font-bold @[240px]:text-[38px]/[44px]'>
                    <NumericFormat
                        value={entireFundsRaised ?? 0.0}
                        thousandSeparator=','
                        decimalScale={2}
                        prefix={'$'}
                        displayType='text'
                        fixedDecimalScale
                    />
                </div>
                <div className='text-[16px]/[24px] text-[#686868]'>
                    Since Campaign Start
                </div>
                {/* {mipBalance !== undefined && mipBalance !== null && (
                    <div className='flex items-center justify-between text-[16px]/[24px] text-[#686868]'>
                        <span>
                            <NumericFormat
                                value={mipBalance}
                                thousandSeparator=','
                                decimalScale={2}
                                prefix={'$'}
                                displayType='text'
                                fixedDecimalScale
                            />
                            {' (Available)'}
                        </span>
                        {onRefreshBalance && (
                            <button
                                onClick={onRefreshBalance}
                                disabled={isRefreshing}
                                className={`ml-2 p-1 ${isRefreshing
                                        ? 'cursor-not-allowed opacity-50'
                                        : 'cursor-pointer'
                                    }`}
                                title='Refresh funds raised from MIP'
                            >
                                <FaSync
                                    className={`text-[#00AEB3] ${isRefreshing ? 'animate-spin' : ''
                                        }`}
                                    size={14}
                                />
                            </button>
                        )}
                    </div>
                )} */}
            </Panel>
        </>
    );
};

export default FundsRaisedBlock;
